export default __webpack_public_path__ + "static/media/506.37a78973.jpg";